// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*======================
  GLOBAL VARIABLES & BASE
======================*/
:root {
  --primary: #00bfb4;
  --secondary: #001716;
  --light: #f2f2f2;
  --black: #494949;
  --grey: #cbcbcb;
  --text: #515151;
  --hover: #008b83;
  --seperator: #00312e;
  --black-high: #000000;
  --black-low: #929292;
  --primary-light: #d0fffc;
}

p,
span,
label,
input,
sup,
sub,
textarea,
select,
a,
ul,
ol,
li,
small,
strong,
th,
td,
tr,
u {
  font-family: var(--font-family-alt);
}

h1,
h2,
h3,
h4,
h5,
h6,
button {
  font-family: var(--font-family-alt);
}

.cursor-pointer {
  cursor: pointer;
}

.w-fit {
  width: fit-content;
}

/*======================
  TEXT UTILITIES
======================*/
.primary-text {
  color: var(--primary);
  font-weight: 400;
  font-size: 14px;
}

.desc-text {
  color: var(--text);
  font-size: 14px;
  font-weight: 400;
}

.primary-hover-text {
  color: var(--primary);
  font-weight: 400;
  font-size: 14px;
  transition: all ease-in-out 300ms;
}

.primary-hover-text:hover {
  color: var(--hover);
}

/*======================
  MAIN CONTAINER
======================*/
.main {
  min-height: calc(56vh + 5px);
  position: relative;
}

/*======================
  BUTTONS
======================*/
.primary-btn {
  color: white !important;
  background-color: var(--primary);
  font-size: 16px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 50px;
}

.primary-btn:hover {
  background-color: var(--hover);
}

.primary-btn.reset {
  background-color: var(--grey);
  color: var(--text) !important;
}

.primary-btn.reset:hover {
  background-color: var(--black-low);
  color: var(--light) !important;
}

/*======================
  NO DATA FOUND CONTAINER
======================*/
.noDataFound-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--light);
  height: 100%;
  position: absolute;
  width: 100%;
}

/*======================
  FORM ELEMENTS
======================*/
.form-row {
  margin-bottom: 1rem;
}

.form-row label {
  display: block;
  margin-bottom: 10px;
  font-size: 15px;
  color: #000;
  font-weight: 400;
}

.form-input {
  padding: 9px 12px;
  border: 1px solid #a7a29e !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #a7a29e;
  height: 42px;
  width: 100%;
  border-radius: 3px !important;
}

.form-input::placeholder {
  font-size: 15px;
  color: var(--grey);
  font-weight: 400;
}

.p-multiselect {
  width: 100%;
}

.p-inputtext:enabled:focus,
.p-button.p-button-secondary:enabled:focus,
.p-button:focus {
  box-shadow: none !important;
}

.p-inputtext:enabled:hover {
  border-color: inherit !important;
}

:focus-visible {
  outline: none;
}

.form-select:focus {
  box-shadow: none;
}

.form-row .p-multiselect .p-multiselect-label {
  padding: 0 !important;
}

.common-form-wrapper {
  background-color: #fff;
  padding: 20px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
}

/*======================
  DASHBOARD STYLES
======================*/
.dashbord-usr {
  padding: 20px 0;
}

.aside-usr {
  background-color: var(--light);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.aside-detail-box-usr {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--grey);
}

.aside-detail-box-icon-usr {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary);
  border-radius: 50%;
  color: #fff;
  font-size: 18px;
}

.aside-usr ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

.aside-usr ul li .upload-heading {
  display: block;
  text-align: center;
  text-decoration: none;
  margin-bottom: 15px;
  font-weight: 600;
  color: var(--primary);
  transition: color 0.3s;
}

.aside-usr ul li .upload-heading:hover {
  color: var(--dark);
}

.aside-outlet-wrapper-usr {
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

/*======================
  RESPONSIVE
======================*/
@media (max-width: 991px) {
  .aside-outlet-wrapper-usr {
    padding: 20px;
  }

  .aside-usr {
    padding: 15px;
  }

  .aside-detail-box-usr {
    margin-bottom: 20px;
    padding-bottom: 15px;
  }
}

@media (max-width: 767px) {
  .dashbord-usr {
    padding: 15px 0;
  }

  .aside-usr,
  .aside-outlet-wrapper-usr {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .aside-detail-box-icon-usr {
    height: 35px;
    width: 35px;
    font-size: 16px;
  }

  .aside-usr ul li .upload-heading {
    font-size: 14px;
  }
}

/*======================
  LOCATION & FILE UPLOAD
======================*/
.common-location-btn.form-input {
  background: var(--primary) !important;
  color: #fff;
  width: 100%;
  border-color: var(--primary) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease;
}

.common-location-btn.form-input:hover {
  background: var(--hover);
}

.common-location-btn.form-input.btn:first-child:active {
  color: #fff;
}

.common-location-btn.form-input .p-button-label {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: #fff;
}

.common-location-btn.form-input.cancel {
  background: var(--grey) !important;
  border-color: var(--grey) !important;
  padding: 0 70px;
}

.common-location-btn.form-input.cancel .p-button-label {
  color: var(--text) !important;
}

.select-location-btn-wrapper {
  display: flex;
  justify-content: space-between;
}

.select-location-btn-wrapper .common-location-btn.form-input {
  padding: 0 70px;
}
/* ===== Hotel step 4: guests & contact ===== */
.ht-guest-step {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ht-card {
  background: #fff;
  border: 1px solid #e6e8ec;
  border-radius: 12px;
  padding: 12px 14px;
}

.ht-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2430;
}
.ht-card__title i {
  color: var(--fv-primary, #0b7a5a);
  font-size: 13px;
}

/* Counter rows */
.ht-counter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}
.ht-counter + .ht-counter {
  border-top: 1px dashed #eceef2;
}

.ht-counter__text {
  display: flex;
  flex-direction: column;
}
.ht-counter__label {
  font-size: 14px;
  font-weight: 500;
  color: #1f2430;
}
.ht-counter__hint {
  font-size: 12px;
  color: #8a909c;
}

.ht-counter__controls {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ht-counter__value {
  min-width: 18px;
  text-align: center;
  font-size: 15px;
}

.ht-counter__btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #cfd4dc;
  background: #fff;
  color: #1f2430;
  display: grid;
  place-items: center;
  font-size: 12px;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s;
}
.ht-counter__btn:hover:not(:disabled) {
  border-color: var(--fv-primary, #0b7a5a);
  color: var(--fv-primary, #0b7a5a);
}
.ht-counter__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* Fields */
.ht-field {
  display: block;
  margin: 0 0 10px;
}
.ht-field:last-child {
  margin-bottom: 0;
}

.ht-field__label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #5b6270;
  margin-bottom: 4px;
}
.ht-field__label em {
  font-style: normal;
  color: #9aa0ab;
  font-weight: 400;
}

.ht-field__control {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 12px;
  border: 1px solid #d8dce3;
  border-radius: 10px;
  background: #fafbfc;
  transition:
    border-color 0.15s,
    box-shadow 0.15s,
    background 0.15s;
}
.ht-field__control:focus-within {
  border-color: var(--fv-primary, #0b7a5a);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(11, 122, 90, 0.12);
}
.ht-field__control.is-invalid {
  border-color: #e04b4b;
}
.ht-field__control i {
  color: #9aa0ab;
  font-size: 13px;
  width: 14px;
}

.ht-field__control input,
.ht-field__control textarea {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 14px;
  color: #1f2430;
  padding: 0;
}

.ht-field__control--area {
  height: auto;
  padding: 8px 12px;
  align-items: flex-start;
}
.ht-field__control--area textarea {
  resize: none;
  line-height: 1.4;
  font-family: inherit;
}

.ht-field__prefix {
  font-size: 14px;
  color: #5b6270;
  padding-right: 8px;
  border-right: 1px solid #e0e3e8;
}

.ht-field__error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #e04b4b;
}

.ht-nights-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  color: #5b6270;
}
`, "",{"version":3,"sources":["webpack://./src/css/global.css"],"names":[],"mappings":"AAAA;;uBAEuB;AACvB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,mCAAmC;AACrC;;AAEA;;;;;;;EAOE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;uBAEuB;AACvB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;uBAEuB;AACvB;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;uBAEuB;AACvB;EACE,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;uBAEuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;;uBAEuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb;;iCAE+B;AACjC;;AAEA;;uBAEuB;AACvB;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;uBAEuB;AACvB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;uBAEuB;AACvB;EACE,qCAAqC;EACrC,WAAW;EACX,WAAW;EACX,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;AACA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf;;oBAEkB;AACpB;AACA;EACE,wCAAwC;EACxC,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB;;;oBAGkB;AACpB;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,cAAc;AAChB","sourcesContent":["/*======================\n  GLOBAL VARIABLES & BASE\n======================*/\n:root {\n  --primary: #00bfb4;\n  --secondary: #001716;\n  --light: #f2f2f2;\n  --black: #494949;\n  --grey: #cbcbcb;\n  --text: #515151;\n  --hover: #008b83;\n  --seperator: #00312e;\n  --black-high: #000000;\n  --black-low: #929292;\n  --primary-light: #d0fffc;\n}\n\np,\nspan,\nlabel,\ninput,\nsup,\nsub,\ntextarea,\nselect,\na,\nul,\nol,\nli,\nsmall,\nstrong,\nth,\ntd,\ntr,\nu {\n  font-family: var(--font-family-alt);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nbutton {\n  font-family: var(--font-family-alt);\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.w-fit {\n  width: fit-content;\n}\n\n/*======================\n  TEXT UTILITIES\n======================*/\n.primary-text {\n  color: var(--primary);\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.desc-text {\n  color: var(--text);\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.primary-hover-text {\n  color: var(--primary);\n  font-weight: 400;\n  font-size: 14px;\n  transition: all ease-in-out 300ms;\n}\n\n.primary-hover-text:hover {\n  color: var(--hover);\n}\n\n/*======================\n  MAIN CONTAINER\n======================*/\n.main {\n  min-height: calc(56vh + 5px);\n  position: relative;\n}\n\n/*======================\n  BUTTONS\n======================*/\n.primary-btn {\n  color: white !important;\n  background-color: var(--primary);\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 50px;\n}\n\n.primary-btn:hover {\n  background-color: var(--hover);\n}\n\n.primary-btn.reset {\n  background-color: var(--grey);\n  color: var(--text) !important;\n}\n\n.primary-btn.reset:hover {\n  background-color: var(--black-low);\n  color: var(--light) !important;\n}\n\n/*======================\n  NO DATA FOUND CONTAINER\n======================*/\n.noDataFound-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--light);\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n\n/*======================\n  FORM ELEMENTS\n======================*/\n.form-row {\n  margin-bottom: 1rem;\n}\n\n.form-row label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 15px;\n  color: #000;\n  font-weight: 400;\n}\n\n.form-input {\n  padding: 9px 12px;\n  border: 1px solid #a7a29e !important;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n  color: #a7a29e;\n  height: 42px;\n  width: 100%;\n  border-radius: 3px !important;\n}\n\n.form-input::placeholder {\n  font-size: 15px;\n  color: var(--grey);\n  font-weight: 400;\n}\n\n.p-multiselect {\n  width: 100%;\n}\n\n.p-inputtext:enabled:focus,\n.p-button.p-button-secondary:enabled:focus,\n.p-button:focus {\n  box-shadow: none !important;\n}\n\n.p-inputtext:enabled:hover {\n  border-color: inherit !important;\n}\n\n:focus-visible {\n  outline: none;\n}\n\n.form-select:focus {\n  box-shadow: none;\n}\n\n.form-row .p-multiselect .p-multiselect-label {\n  padding: 0 !important;\n}\n\n.common-form-wrapper {\n  background-color: #fff;\n  padding: 20px;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.12),\n    0 1px 2px rgba(0, 0, 0, 0.24);\n}\n\n/*======================\n  DASHBOARD STYLES\n======================*/\n.dashbord-usr {\n  padding: 20px 0;\n}\n\n.aside-usr {\n  background-color: var(--light);\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n}\n\n.aside-detail-box-usr {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--grey);\n}\n\n.aside-detail-box-icon-usr {\n  height: 40px;\n  width: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--primary);\n  border-radius: 50%;\n  color: #fff;\n  font-size: 18px;\n}\n\n.aside-usr ul {\n  list-style-type: none;\n  padding-left: 0;\n  margin: 0;\n}\n\n.aside-usr ul li .upload-heading {\n  display: block;\n  text-align: center;\n  text-decoration: none;\n  margin-bottom: 15px;\n  font-weight: 600;\n  color: var(--primary);\n  transition: color 0.3s;\n}\n\n.aside-usr ul li .upload-heading:hover {\n  color: var(--dark);\n}\n\n.aside-outlet-wrapper-usr {\n  padding: 30px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n}\n\n/*======================\n  RESPONSIVE\n======================*/\n@media (max-width: 991px) {\n  .aside-outlet-wrapper-usr {\n    padding: 20px;\n  }\n\n  .aside-usr {\n    padding: 15px;\n  }\n\n  .aside-detail-box-usr {\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n  }\n}\n\n@media (max-width: 767px) {\n  .dashbord-usr {\n    padding: 15px 0;\n  }\n\n  .aside-usr,\n  .aside-outlet-wrapper-usr {\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .aside-detail-box-icon-usr {\n    height: 35px;\n    width: 35px;\n    font-size: 16px;\n  }\n\n  .aside-usr ul li .upload-heading {\n    font-size: 14px;\n  }\n}\n\n/*======================\n  LOCATION & FILE UPLOAD\n======================*/\n.common-location-btn.form-input {\n  background: var(--primary) !important;\n  color: #fff;\n  width: 100%;\n  border-color: var(--primary) !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.2s ease;\n}\n\n.common-location-btn.form-input:hover {\n  background: var(--hover);\n}\n\n.common-location-btn.form-input.btn:first-child:active {\n  color: #fff;\n}\n\n.common-location-btn.form-input .p-button-label {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: center;\n  color: #fff;\n}\n\n.common-location-btn.form-input.cancel {\n  background: var(--grey) !important;\n  border-color: var(--grey) !important;\n  padding: 0 70px;\n}\n\n.common-location-btn.form-input.cancel .p-button-label {\n  color: var(--text) !important;\n}\n\n.select-location-btn-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.select-location-btn-wrapper .common-location-btn.form-input {\n  padding: 0 70px;\n}\n/* ===== Hotel step 4: guests & contact ===== */\n.ht-guest-step {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ht-card {\n  background: #fff;\n  border: 1px solid #e6e8ec;\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n\n.ht-card__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2430;\n}\n.ht-card__title i {\n  color: var(--fv-primary, #0b7a5a);\n  font-size: 13px;\n}\n\n/* Counter rows */\n.ht-counter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n}\n.ht-counter + .ht-counter {\n  border-top: 1px dashed #eceef2;\n}\n\n.ht-counter__text {\n  display: flex;\n  flex-direction: column;\n}\n.ht-counter__label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f2430;\n}\n.ht-counter__hint {\n  font-size: 12px;\n  color: #8a909c;\n}\n\n.ht-counter__controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.ht-counter__value {\n  min-width: 18px;\n  text-align: center;\n  font-size: 15px;\n}\n\n.ht-counter__btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #cfd4dc;\n  background: #fff;\n  color: #1f2430;\n  display: grid;\n  place-items: center;\n  font-size: 12px;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n}\n.ht-counter__btn:hover:not(:disabled) {\n  border-color: var(--fv-primary, #0b7a5a);\n  color: var(--fv-primary, #0b7a5a);\n}\n.ht-counter__btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* Fields */\n.ht-field {\n  display: block;\n  margin: 0 0 10px;\n}\n.ht-field:last-child {\n  margin-bottom: 0;\n}\n\n.ht-field__label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #5b6270;\n  margin-bottom: 4px;\n}\n.ht-field__label em {\n  font-style: normal;\n  color: #9aa0ab;\n  font-weight: 400;\n}\n\n.ht-field__control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 42px;\n  padding: 0 12px;\n  border: 1px solid #d8dce3;\n  border-radius: 10px;\n  background: #fafbfc;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s,\n    background 0.15s;\n}\n.ht-field__control:focus-within {\n  border-color: var(--fv-primary, #0b7a5a);\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(11, 122, 90, 0.12);\n}\n.ht-field__control.is-invalid {\n  border-color: #e04b4b;\n}\n.ht-field__control i {\n  color: #9aa0ab;\n  font-size: 13px;\n  width: 14px;\n}\n\n.ht-field__control input,\n.ht-field__control textarea {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  font-size: 14px;\n  color: #1f2430;\n  padding: 0;\n}\n\n.ht-field__control--area {\n  height: auto;\n  padding: 8px 12px;\n  align-items: flex-start;\n}\n.ht-field__control--area textarea {\n  resize: none;\n  line-height: 1.4;\n  font-family: inherit;\n}\n\n.ht-field__prefix {\n  font-size: 14px;\n  color: #5b6270;\n  padding-right: 8px;\n  border-right: 1px solid #e0e3e8;\n}\n\n.ht-field__error {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #e04b4b;\n}\n\n.ht-nights-hint {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  font-size: 12px;\n  color: #5b6270;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
